<div class="auth">
  <div class="auth__glow" aria-hidden="true"></div>

  <header class="auth__top">
    <a routerLink="/" class="auth-brand" aria-label="PulseWatch home">
      <span class="auth-brand__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64"><path d="M9 35h11l5-12 8 24 6-17 3 5h13" /></svg>
      </span>
      <span class="auth-brand__name">PulseWatch</span>
    </a>
    <a routerLink="/knowledge-base" class="auth__help">Help</a>
  </header>

  <main class="auth__main auth__main--single">
    <section class="auth-card">
      @if (!projectUuid) {
        <h1>Request access</h1>
        <p class="auth-card__sub" data-testid="request-no-link">
          Open the PulseWatch link you were sent (for example to an error or a project) and choose
          <strong>Request access</strong> on the login page. We need that link to know which team to ask.
        </p>
        <p class="auth-card__alt"><a routerLink="/login" class="auth-link">Back to log in</a></p>
      } @else if (sent()) {
        <div class="auth-success" data-testid="request-sent">
          <div class="auth-success__icon"><i class="bx bx-check"></i></div>
          <h1>Request sent</h1>
          <p>The team that owns this project will see your request. If they approve it, you’ll get an email invitation.</p>
        </div>
        <p class="auth-card__alt"><a routerLink="/login" class="auth-link">Back to log in</a></p>
      } @else {
        <h1>Request access</h1>
        <p class="auth-card__sub">
          You opened a link to a PulseWatch project you’re not a member of. Ask its team to invite you.
        </p>

        <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <label class="auth-field">
            <span>Your name</span>
            <div class="auth-field__box" [class.is-invalid]="invalid('name')">
              <i class="bx bx-user" aria-hidden="true"></i>
              <input type="text" formControlName="name" placeholder="Hans Müller" autocomplete="name" data-testid="request-name" />
            </div>
            @if (has('name', 'required')) {
              <small class="auth-field__error">Required.</small>
            }
          </label>

          <label class="auth-field">
            <span>Work email</span>
            <div class="auth-field__box" [class.is-invalid]="invalid('email')">
              <i class="bx bx-envelope" aria-hidden="true"></i>
              <input type="email" formControlName="email" placeholder="you@company.com" autocomplete="email" inputmode="email" data-testid="request-email" />
            </div>
            @if (has('email', 'required')) {
              <small class="auth-field__error">Email is required.</small>
            } @else if (has('email', 'email')) {
              <small class="auth-field__error">Please enter a valid email address.</small>
            }
          </label>

          <label class="auth-field">
            <span>Message <span class="auth-optional">(optional)</span></span>
            <div class="auth-field__box">
              <textarea formControlName="message" maxlength="1000" placeholder="Why you need access, e.g. “I’m fixing the checkout error.”" data-testid="request-message"></textarea>
            </div>
          </label>

          @if (formError()) {
            <div class="auth-alert" role="alert"><i class="bx bx-error-circle"></i>{{ formError() }}</div>
          }

          <button type="submit" class="auth-btn" [disabled]="submitting()" data-testid="request-submit">
            @if (submitting()) {
              <span class="auth-btn__spinner" aria-hidden="true"></span> Sending…
            } @else {
              Request access <i class="bx bx-right-arrow-alt"></i>
            }
          </button>
        </form>

        <p class="auth-card__alt">Already a member? <a routerLink="/login" [fragment]="path" class="auth-link">Log in</a></p>
      }
    </section>
  </main>

  <footer class="auth__footer">{{ versions.hash }} · {{ versions.date | date: 'short' }}</footer>
</div>
